/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Platform API
 * Agency-facing API — day-to-day platform usage by agency users.
 * OpenAPI spec version: 1.0
 */

export type PlayersControllerListPlayersV1ContractStatus = typeof PlayersControllerListPlayersV1ContractStatus[keyof typeof PlayersControllerListPlayersV1ContractStatus];


export const PlayersControllerListPlayersV1ContractStatus = {
  none: 'none',
  expired: 'expired',
  expiring: 'expiring',
  active: 'active',
} as const;
